import { render, staticRenderFns } from "./premiumVideoList.vue?vue&type=template&id=4fccdfa4&"
import script from "./premiumVideoList.vue?vue&type=script&lang=js&"
export * from "./premiumVideoList.vue?vue&type=script&lang=js&"
import style0 from "./premiumVideoList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports